/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'circle': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M256 0C114.837 0 0 114.837 0 256s114.837 256 256 256 256-114.837 256-256S397.163 0 256 0z"/>'
  }
})
